import * as Types from 'constants/ActionTypes';

export const updateStateful = (id, key, value) => dispatch => {
	dispatch({
		type: Types.UPDATE_STATEFUL,
		payload: {
			id, key, value
		}
	})
}